import React from 'react';

// Renders the session_diagnostics array from an igloo_exited event:
// a chronological list of in-session events (Zoom join/error, audio track
// creation, RTDB listener, remote-subscriber events, etc.) emitted by the
// device during the session.
//
// Each entry has shape: { t: <ms-from-session-start>, e: "<event_name>", ...extras }

const EVENT_STYLES = [
  { match: (e) => /error|_fail/.test(e), classes: 'text-red-600 font-medium' },
  { match: (e) => e === 'zoom_joined' || e === 'remote_subscribed', classes: 'text-green-600 font-medium' },
  { match: (e) => e.startsWith('remote_'), classes: 'text-cyan-600' },
  { match: (e) => e.startsWith('zoom_'), classes: 'text-fuchsia-600' },
  { match: (e) => e.startsWith('audio') || e.startsWith('hdmi'), classes: 'text-amber-600' },
];

function eventClass(name) {
  for (const rule of EVENT_STYLES) {
    if (rule.match(name)) return rule.classes;
  }
  return 'text-foreground';
}

function formatT(t) {
  if (typeof t !== 'number') return '?';
  return `${(t / 1000).toFixed(1)}s`;
}

function SessionEventsView({ diagnostics }) {
  if (!diagnostics || diagnostics.length === 0) {
    return (
      <div className="text-sm text-muted-foreground py-6 text-center">
        No session_diagnostics on this exit event.
      </div>
    );
  }

  return (
    <div className="space-y-1 font-mono text-xs">
      {diagnostics.map((d, i) => {
        const extras = Object.entries(d).filter(([k]) => k !== 't' && k !== 'e');
        return (
          <div key={i} className="flex items-baseline gap-3">
            <span className="text-muted-foreground tabular-nums w-16 text-right shrink-0">
              t={formatT(d.t)}
            </span>
            <span className={`${eventClass(d.e)} shrink-0`}>{d.e}</span>
            {extras.length > 0 && (
              <span className="text-muted-foreground truncate">
                {extras.map(([k, v]) => `${k}=${v}`).join('  ')}
              </span>
            )}
          </div>
        );
      })}
    </div>
  );
}

export default SessionEventsView;
